module.exports = __webpack_public_path__ + "img/checkmark.0691ea51.svg";